import { formatPhone, phoneView } from '@/common/utils/strings';
import clsx from 'clsx';
import dayjs from 'dayjs';
import { isMobile } from '../utils';
const styleAttribute = (attributes) => {
  return Object.entries(attributes).reduce((acc, item) => {
    const [key, value] = item;
    return [...acc, `${key}: ${value}`];
  }, []).join(';');
};

export const cssPlugin = () => {
  return (component) => {
    component.$css = styleAttribute;
    return component;
  };
};

export const helperPlugin = () => {
  let isTablet = isMobile();
  return (component) => {
    component.isTablet = isTablet;
    component.formatPhone = formatPhone;
    component.phoneView = phoneView;
    component.dayjs = dayjs;
    component.$clsx = clsx;
    return component;
  };
};